














import Vue from "vue";
import iwInputGroupStepper from "@/encoding/components/buildingBlocks/InputGroupStepper.vue";

export default Vue.extend({
    components: {
        iwInputGroupStepper: iwInputGroupStepper
    },
    data: function() {
        return {
            pathInStore: "property.parking.parkingSpaceCount.outdoor",
            pathInStoreUI: "property.hasParkingSpace"
        };
    },
    computed: {
        parkingSpaceCountOutdoor: function(): number | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        hasParkingSpace: function(): boolean {
            return this.$store.getters["FormModule/getValueUI"](this.pathInStoreUI);
        }
    },
    methods: {
        updateValue: function(parkingSpaceCountOutdoor: number): void {
            if (!this.hasParkingSpace || (parkingSpaceCountOutdoor === 0 && this.parkingSpaceCountOutdoor != null)) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": parkingSpaceCountOutdoor});
            }
        }
    }
});

